<template>
    <BreadCrumb PageTitle="Modifier un rayon" />
    <EditRayon />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditRayon from "../../components/Rayon/EditRayon.vue";
  
    export default defineComponent({
      name: "EditRayonPage",
      components: {
        BreadCrumb,
        EditRayon,
      },
    });
  </script>